// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HZ6s","left":"styles_left__1U14K"};